import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
// Estilos do shell: antes do index.css para as utilitárias do Tailwind prevalecerem.
import './styles/shell.css'
import './index.css'
import { installScopeHeaders } from './lib/scopeHeaders'
import { ThemeProvider, applyThemeEarly } from './contexts/ThemeContext'
import { ToastProvider } from './contexts/ToastContext'

installScopeHeaders()
applyThemeEarly()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
